let Modal = require('modal-react-native-web');
export default Modal;


